export enum RegisterOrigin {
  PremiumLandingPage = 'premium_landing_page',
  Blog = 'blog',
}
